import Box from '@mui/material/Box';
import PageTitle from '../../../components/PageTitle';
import { currentUser } from '../../../store';
import { useRecoilValue } from 'recoil';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { commonStyles } from '../reorder-pro/style';
import LoadingButton from "@mui/lab/LoadingButton";

import { Button, Typography } from '@mui/material';
import { Download, UploadFile } from '@mui/icons-material';
import { fil } from 'date-fns/locale';

const InputTables = () => {
  const { moduleId } = useParams();
  const user = useRecoilValue(currentUser);
  const [isValidating, setIsValidating] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const uploadTable = user?.userPermissions?.filter(m => m.id === parseInt(moduleId, 10));
  const uploadType = uploadTable?.length > 0 ? uploadTable[0].name : 'Input';
  const pageTitle = `Table: ${uploadType}`;

  const moduleSettings = user?.orgSettings?.find(setting => setting.scoped_entity_id === parseInt(moduleId, 10) && setting.scope === 'module' && setting.setting_key === 'filename');
  console.log('Module settings:', moduleSettings);

  const filename = moduleSettings.setting_value
  console.log('Filename:', filename);
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files.length) {
      simulateValidation(e.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileInputChange = (e) => {
    if (e.target.files.length) {
      simulateValidation(e.target.files[0]);
    }
  };

  const simulateValidation = (file) => {
    setUploadedFile(file);
    setIsValidating(true);
    setIsValidated(false);
    setTimeout(() => {
      setIsValidating(false);
      setIsValidated(true);
    }, 1000); // 1 second fake validation delay
  };


  return (
    <Box sx={{
      padding: '25px',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '30px',
      height: '100%'
    }}>
      <PageTitle>
        {pageTitle}
      </PageTitle>
      <Box sx={{
        display: 'flex',
        marginTop: '30px',
        justifyContent: 'space-between',
        justifyContent: 'center',
      }}>
        <Box
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          sx={{
            border: '2px dashed #aaa',
            borderRadius: 2,
            width: '80%',
            height: '500px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            py: 4,
            cursor: 'pointer',
          }}
          onClick={() => document.getElementById('csv-upload-input').click()}
        >
          <UploadFile sx={{ fontSize: 40 }} />
          <Typography mt={1}>
            Drag & drop the '{uploadType}' file here or click to upload
          </Typography>
          <input
            type="file"
            id="csv-upload-input"
            accept=".csv"
            hidden
            onChange={handleFileInputChange}
          />
        </Box>
        {isValidating && (
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body2">Validating file...</Typography>
            <span className="spinner" />
          </Box>
        )}

        {isValidated && uploadedFile && (
          <Typography variant="body2">
            File validated and uploaded: {uploadedFile.name}
          </Typography>
        )}

      </Box>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}>
        <LoadingButton
          variant="contained"
          startIcon={<Download />}
          component="a"
          sx={{ ...commonStyles.controlButton }}
          href={`https://storage.growthsayer.com/demo/${filename}`}
          download={filename}
          fullWidth
        >
          Download '{uploadType}' Table
        </LoadingButton>
      </Box>
    </Box>
  );
};
export default InputTables;